var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height",attrs:{"id":"adminlanding"}},[_c('section',{staticClass:"fill-height"},[_c('v-container',{staticClass:"text-center fill-height pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"videoWrapper"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"scrolling":"no","frameborder":"0","allowfullscreen":""}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }